/*
  TW-206: browser zoom has no media query — it only shrinks the viewport in CSS px, so
  width breakpoints fire the mobile layout on a zoomed desktop. outerWidth is in screen
  coordinates and ignores zoom, innerWidth does not, so their ratio is the zoom level.

  Loaded WITHOUT defer from <head> on purpose: the class must land before first paint, or
  every load at zoom flashes the mobile layout first.

  ponytail: class only, nothing keyed off it yet. Known ceilings for the `> 1` threshold —
  it holds on macOS (no window borders, overlay scrollbars, so the ratio is exactly 1 at
  100%), but on Windows/Linux the frame and classic scrollbar make innerWidth smaller than
  outerWidth at 100% zoom too, so the ratio creeps just over 1 and the class sticks. Docked
  DevTools does the same. If QA sees that, raise the threshold to ~1.1 rather than adding
  platform sniffing. Android Chrome's meta-viewport scale can also skew the ratio — add a
  matchMedia('(pointer: fine)') guard if mobile false positives show up.
*/
(function () {
  var root = document.documentElement;

  function setZoom() {
    const isZoomed = window.outerWidth / window.innerWidth > 1;
    root.classList.toggle('is-zoomed', isZoomed);
  }

  setZoom();
  addEventListener('resize', setZoom);
})();
